// extracted by mini-css-extract-plugin
export default {"rectangle":"dialer_rectangle__Mkx0d","wrapper":"dialer_wrapper__EPgVM","deleteDialer":"dialer_deleteDialer__uwuZD"};